/**
 * Generates a random date between the given start and end dates, with a random hour between the given start and end hours.
 * @param start The start date.
 * @param end The end date.
 * @param startHour The start hour.
 * @param endHour The end hour.
 * @returns A random date between the start and end dates, with a random hour between the start and end hours.
 */
export const randomDate = (
  start: Date,
  end: Date,
  startHour: number,
  endHour: number
): Date => {
  const date = new Date(+start + Math.random() * (+end - +start));
  const hour = (startHour + Math.random() * (endHour - startHour)) | 0;
  date.setHours(hour);
  return date;
};
